import { ArrowLeftOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Skeleton, Typography } from "antd";
import { Link, useNavigate } from "react-router-dom";
import type { Organization } from "../types";

const { Title, Text } = Typography;

interface OrgDetailHeaderProps {
	org: Organization | undefined;
	isLoading: boolean;
	onTitleClick?: () => void;
}

export function OrgDetailHeader({ org, isLoading, onTitleClick }: OrgDetailHeaderProps) {
	const navigate = useNavigate();

	return (
		<div className="mb-6">
			<div className="flex items-center gap-2 mb-3">
				<Button
					type="text"
					icon={<ArrowLeftOutlined />}
					onClick={() => navigate(-1)}
					size="small"
					className="text-gray-500 hover:text-gray-700 -ml-1"
					id="org-detail-back-btn"
				/>
				<Breadcrumb
					items={[
						{ title: <Link to="/">Asosiy</Link> },
						{ title: <Link to="/organizations">Tashkilotlar</Link> },
						{
							title: isLoading ? (
								<Skeleton.Input size="small" active style={{ width: 120, height: 14 }} />
							) : (
								<span className="text-gray-600">{org?.name}</span>
							),
						},
					]}
					className="text-sm"
				/>
			</div>

			{isLoading ? (
				<div className="space-y-2">
					<Skeleton.Input active style={{ width: 280, height: 28 }} />
					<Skeleton.Input active size="small" style={{ width: 200, height: 16 }} />
				</div>
			) : (
				<div>
					<Title
						level={4}
						className={`mb-1! font-semibold! text-xl! ${
							onTitleClick ? "cursor-pointer hover:text-blue-600 transition-colors" : ""
						}`}
						onClick={onTitleClick}
					>
						{org?.name ?? "—"}
					</Title>
					<Text type="secondary" className="text-sm">
						{org?.type?.name}
						{org?.soato?.nameUz ? ` · ${org.soato.nameUz}` : ""}
					</Text>
				</div>
			)}
		</div>
	);
}
